import React from 'react';
import DialogHeader from '@/components/shared/DialogHeader';
import { HeaderConfig } from '../types';
import { CentralizedMobileDetection } from '@/hooks/useCentralizedMobileDetection';

interface StandardDialogHeaderProps extends HeaderConfig {
  detection?: CentralizedMobileDetection;
}

/**
 * StandardDialogHeader
 * ----------------------------------------------------------------------------
 * Thin adapter that:
 * - Maps template-level header config to the shared <DialogHeader /> component
 * - Translates `variant="standard"` -> `DialogHeader`'s `regular` variant
 * - Passes mobile detection through so the header can respect safe-areas
 *
 * IMPORTANT:
 * - Do NOT wrap in a fixed-height container; <DialogHeader> manages its own
 *   sticky/safe-area layout and minimum height. A fixed height (like `h-12`)
 *   can cause clipping and overlap with the safe area or scroll container.
 */
const StandardDialogHeader: React.FC<StandardDialogHeaderProps> = ({
  showLogo = true,            // kept for compatibility (not used by DialogHeader)
  showAvatar = true,          // kept for compatibility (not used by DialogHeader)
  showHints = false,
  prayer,
  isExpanded = false,
  onToggle,
  onClose,
  onBackClick,
  customLeftSection,
  customRightSection,
  variant = 'audio',
  swipeState,
  detection,
}) => {
  // Map template "standard" to DialogHeader's "regular"
  const dialogHeaderVariant: 'audio' | 'regular' | 'primary' | 'minimal' =
    variant === 'standard' ? 'regular' : variant;

  return (
    <div className="relative">
      <DialogHeader
        variant={dialogHeaderVariant}
        isExpanded={isExpanded}
        onToggle={onToggle}
        onClose={onClose}
        onBackClick={onBackClick}
        customLeftSection={customLeftSection}
        customRightSection={customRightSection}
        showHints={showHints}
        prayer={prayer}
        swipeState={swipeState}
        isMobile={detection?.isMobile}
      />
    </div>
  );
};

export default StandardDialogHeader;
export { StandardDialogHeader };
